export class UserQueueViewEntry {
    id?: number;
    userId: string;
    displayName: string;
    isDefault: boolean;
    applicationCategoryId: string;
  }
  